import React from 'react'
import Image from '../../../images/sellerpolicies/12.png'

const Parcel_order_lost = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Parcel / Order lost</h2>
            <p>In case a Seller’s Product is lost by KAAY and/or 3PL during transit or handling, KAAY will reimburse the Seller for the Product on cost value.</p>
        </div>
      </div>
    </div>
  )
}

export default Parcel_order_lost
